import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable()
export class WsUrlsService {

  private baseUrl = environment.wsBaseUrl;
  // private baseUrl = firebaseConfig.databaseURL;

  constructor() { }

  // Condivise
  postLogin(): string {
    return `${this.baseUrl}/api/v1/token`;
  }

  postLogout(): string {
    // TODO implementare questa logica sul logout
    return `${this.baseUrl}/api/v1/Account/Logout`;
  }

  postForgot(): string {
    return `${this.baseUrl}/api/v1/Account/ForgotPassword`;
  }

  postReset(): string {
    return `${this.baseUrl}/api/v1/Account/ResetPassword`;
  }

  postRegister(): string {
    return `${this.baseUrl}/api/v1/Account/Register`;
  }

  postConfirm(): string {
    return `${this.baseUrl}/api/v1/Account/ConfirmEmail`;
  }

  sendConfirm(): string {
    return `${this.baseUrl}/api/v1/Account/SendConfirm`;
  }

  getMenu(): string {
    return `${this.baseUrl}/api/Menu`;
  }

  getEventAll(): string {
    return `${this.baseUrl}/api/Event/`;
  }

  getEntityAll(): string {
    return `${this.baseUrl}/api/Entity/All`;
  }

  getUserProfile(uid: string) {
    return `${this.baseUrl}/api/UserProfile/${uid}`;
  }

  getCheckUser(uid: string) {
    return `${this.baseUrl}/api/UserProfile/checkUser/${uid}`;
  }

  postRegisterUserProfile(isRegisteredByOperator: boolean, uid: string) {
    return `${this.baseUrl}/api/UserProfile/${isRegisteredByOperator}/${uid}`;
  }

  getEventDetail(eventId: number) {
    return `${this.baseUrl}/api/Event/${eventId}`;
  }

  getEntityDetail(entityId: number) {
    return `${this.baseUrl}/api/Entity/${entityId}`;
  }

  getSubscriberAll() {
    return `${this.baseUrl}/api/Subscriber/All`;
  }

  getSubscriberByEmail(email: string) {
    return `${this.baseUrl}/api/Subscriber/${email}`;
  }

  postReservation(id: number) {
    return `${this.baseUrl}/api/Subscriber/${id}`;
  }

  deleteReservation(id: number) {
    return `${this.baseUrl}/api/Subscriber/${id}`;
  }

  putEvent(id: number) {
    return `${this.baseUrl}/api/Event/${id}`;
  }

  putEntity(id: number) {
    return `${this.baseUrl}/api/Entity/${id}`;
  }

  postEvent() {
    return `${this.baseUrl}/api/Event`;
  }

  deleteEvent(id: number): string {
    return `${this.baseUrl}/api/Event/Detail/${id}`;
  }

  disableEntity(id: number): string {
    return `${this.baseUrl}/api/Entity/Disable/${id}`;
  }

  postEntity() {
    return `${this.baseUrl}/api/Entity`;
  }

  getManifestationAll(): string {
    return `${this.baseUrl}/api/Manifestation/All`;
  }

  getManifestationDetail(id: number): string {
    return `${this.baseUrl}/api/Manifestation/${id}`;
  }

  postManifestation(): string {
    return `${this.baseUrl}/api/Manifestation`;
  }

  putManifestation(id: number): string {
    return `${this.baseUrl}/api/Manifestation/${id}`;
  }

  deleteManifestation(id: number): string {
    return `${this.baseUrl}/api/Manifestation/Detail/${id}`;
  }

}
